import { useEffect } from 'react';
import { entityRoomKeyFromEntityRef, hydratePerformControlFromGet } from '@/state/player/perform-control-ws.store';
import type {
  FlowCueStateV1,
  LiveCueSheetV1,
  MediaAgentRecoveryV1,
  PerformControlV1,
} from '@/types/player/perform-control-v1.types.ts';

/**
 * Seeds the perform-control WS store from GET whenever a fresh snapshot lands.
 * Room reset is owned by `acquirePerformControlRoom` (provider refcount).
 */
export function useHydratePerformControlFromGet(
  entityRef: string | undefined,
  performControl: PerformControlV1 | undefined,
  querySnapshotKey: number | undefined,
  cueState?: FlowCueStateV1,
  cueSheet?: LiveCueSheetV1,
  mediaSequenceIndex?: Record<string, number>,
  mediaAgentRecovery?: MediaAgentRecoveryV1,
) {
  useEffect(() => {
    if (!entityRef || querySnapshotKey == null) return;
    const room = entityRoomKeyFromEntityRef(entityRef);
    if (!room) return;
    if (performControl && performControl.version === 1) {
      hydratePerformControlFromGet(room, performControl, cueState, cueSheet, mediaSequenceIndex, mediaAgentRecovery);
    }
  }, [entityRef, querySnapshotKey, performControl, cueState, cueSheet, mediaSequenceIndex, mediaAgentRecovery]);
}
